import { Injectable } from "@angular/core";
import { PasswordStrength } from "./password-strength.enum";
import { PasswordTest } from "./password-test.model";

@Injectable({
  providedIn: "root"
})
export class StrengthPasswordService {
  getStrength(passwordInput): PasswordTest {
     let result=new PasswordTest();
    result.containsDigit=false;
    result.containsUpper=false;
    result.containsLower=false;
    result.containsSpecial=false;
    result.containsEightChars=false;
    result.clearedValidations=0;
    result.moreThanEighteenChar=false;
    if (passwordInput === "") 
    
    {
      result.strength=PasswordStrength.Weakest;
      return result;
    }
    const bits = this.getOccurrenceScore(passwordInput);
   /* if (bits <= 28) return PasswordStrength.Weakest;
    if (bits >= 28 && bits <= 39) return PasswordStrength.Weak;
    if (bits >= 40 && bits <= 46) return PasswordStrength.Normal;
    if (bits >= 47 && bits <= 53) return PasswordStrength.Strong;
    if (bits >= 54) return PasswordStrength.Strongest;*/
  
    let cnt=0;
bits.forEach(rw=>{
  let score=rw.score;
  	if(score==200){
    result.strength=PasswordStrength.Strongest;
    //break;
      } 
			if(score==22){
        result.containsDigit=true;
        cnt=cnt+1;
      } 
      if(score==23){
        result.containsUpper=true;
        cnt=cnt+1;
      }
      if(score==24){
        result.containsLower=true;
      cnt=cnt+1;
      }
       if(score==25){
      result.containsSpecial=true;
      cnt=cnt+1;
      }
       if(score==26){
         result.containsEightChars=true;
         cnt=cnt+1;
      }
		})
    result.clearedValidations=cnt;
    
    if(result.strength!=PasswordStrength.Strongest){
    if(cnt==0 || cnt==1 ){
      result.strength=PasswordStrength.Weakest;
      
    }
    else if(cnt==2){
      result.strength=PasswordStrength.Weak;
      
    }
    else if(cnt==3){
      result.strength=PasswordStrength.Normal;
      
    }
    else if(cnt==4){
      result.strength=PasswordStrength.Strong;
      
    }
    else {
      result.strength=PasswordStrength.Strongest;
      
    }
    
    
    }
    if(passwordInput.length>18) {
      result.moreThanEighteenChar=true;
      result.strength=PasswordStrength.Strong;
    } else {
      result.moreThanEighteenChar=false;
    }
    return result;
  }

  getOccurrenceScore(passwordInput) {
    let arr=[];
    this.poolOfOccurrence.forEach(rw=>{
    let match=rw.regex.test(passwordInput);
  
    if(match==true){
      arr.push(rw);
    }
    })
    
    //let occurence=this.poolOfOccurrence.find(
      //item => item.regex && item.regex.test(passwordInput)
    //);
    return arr;
   
  }

  private readonly poolOfOccurrence = [
   
     
    {
      regex:  /\d/,
      score: 22
    },
     {
      regex:  /[A-Z]/,
      score: 23
    },
  {
      regex:  /[a-z]/,
      score: 24
    },
    {
      regex: /[!\\"#$%&'()+,-./:;<=>?@[\]]/,
      score: 25
    },
    {
      regex: /.{8,}/,
      score: 26
    },
    
     
   
      ];

  evaluate(poolOfOccurrence, passwordInputLength): number {
    passwordInputLength = passwordInputLength >= 8 ? 8 : passwordInputLength;
    return Math.ceil(
      this.logarithm(Math.pow(poolOfOccurrence, passwordInputLength), 2)
    );
  }
  logarithm(n, base = 10) {
    return Math.log(n) / Math.log(base);
  }

}
